<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <CIcon name="cil-user" size="lg"/>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownDivider/>
    <CDropdownItem>
      <CIcon name="cil-lock-locked" />
        <CHeaderNavLink to="/user" exact>
          Đổi mật khẩu
        </CHeaderNavLink>
      </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem>
      <CIcon name="cil-exit-to-app" />
        <CHeaderNavLink @click.native="logout">
        Đăng xuất
        </CHeaderNavLink></CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
    }
  },
  methods: {
    logout() {
      this.$logout()
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
